import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getApi } from '../../api/endpoints.js';
import Page from "../Page.js";
import FormPartial from "./FormPartial.js";
import PageContentWrapper from "../../components/PageContentWrapper.js";
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import BatteryModel from '../../models/BatteryModel.js';

const Edit = (props) => {
  const [batteryModel, setBatteryModel] = useState((new BatteryModel()).toStateJson());
  const [fetchApi] = getApi('showBatteryModel');
  const [updateApi] = getApi('updateBatteryModel');
  const navigate = useNavigate();

  const params = useParams();

  const getRecord = async (params) => {
    try {
      let response = await fetchApi({ id: params.id }).unwrap();
      setBatteryModel((new BatteryModel(response.data.battery_model)).toStateJson());
    } catch(error) {
    }
  }

  const updateRecord = async (params) => {
    try {
      await updateApi(params).unwrap();
      navigate("/battery_models")
    } catch(error) {
        setBatteryModel((prev_state) => {
          return {
            ...prev_state,
            errors: error.data.data.errors
          }
        })
      }
  }

  useEffect(() => {
    getRecord({ id: params.id })
  }, []);

  const onUpdateClick = () => {
    updateRecord((new BatteryModel(batteryModel)).toApiJson())
  }

  const onBackClick = () => {
    navigate("/battery_models")
  }

  return <Page
    uiPage={uiManager.getUiPage(PAGES.EditBatteryModelPage.name)}
    breadcrumbs={[{ label: "Home", url: '/dashboard'}, { label: "Battery Models", url: '/battery_models' }, { label: "Edit" }]}
    className={'battery-model-edit-page'}
  >
    <PageContentWrapper contentHeading={"Edit Battery Model"}>
      <div className='m-3'>
        <form className="row g-4" autoComplete="off">
          <FormPartial batteryModel={batteryModel} setBatteryModel={setBatteryModel}/>
          <div className='mb-4 col-md-12'>
            <div>
              <button type="button" className="btn btn-voltup-theme" onClick={onBackClick} style={{ float: 'inline-start' }}>Back</button>
              <button type="button" className="btn btn-voltup-theme ms-3" onClick={onUpdateClick}>Update Battery Model</button>
            </div>
          </div>
        </form>
      </div>
    </PageContentWrapper>
  </Page>
};

export default Edit;
